module.exports = __webpack_public_path__ + "static/media/1.06b3a401.jpg";